import QuarterPersonReport from './quarter-person-report.vue'
export default QuarterPersonReport
